var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.99918C0.5 3.80026 0.579018 3.6095 0.71967 3.46885C0.860322 3.32819 1.05109 3.24918 1.25 3.24918H7.19L5.22 1.27918C5.08752 1.137 5.0154 0.948956 5.01883 0.754655C5.02225 0.560354 5.10097 0.374969 5.23838 0.237556C5.37579 0.100142 5.56118 0.0214295 5.75548 0.0180016C5.94978 0.0145736 6.13783 0.0866971 6.28 0.219177L9.53 3.46918C9.67045 3.6098 9.74934 3.80043 9.74934 3.99918C9.74934 4.19793 9.67045 4.38855 9.53 4.52918L6.28 7.77918C6.13783 7.91166 5.94978 7.98378 5.75548 7.98035C5.56118 7.97692 5.37579 7.89821 5.23838 7.7608C5.10097 7.62339 5.02225 7.438 5.01883 7.2437C5.0154 7.0494 5.08752 6.86135 5.22 6.71918L7.19 4.74918H1.25C1.05109 4.74918 0.860322 4.67016 0.71967 4.52951C0.579018 4.38885 0.5 4.19809 0.5 3.99918Z",
    fill: "#078950"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.e542e407.svg";
export { ForwardRef as ReactComponent };